@if (!resultPresent) {
  <div class="noResults">
    <div class="searchResultsPresent">
      <div class="searchResultsAccordions">
        @if (!resultPresent && component.data$ | async; as data) {
          <p
            [innerHTML]="data.content"
          ></p>
        }
      </div>
    </div>
  </div>
}
